import React, { useState, useEffect, useContext } from "react";
import { useNavigate, Routes, Route } from "react-router-dom";
import TNLogo from "../Constant/Icons/TamilNadu_Logo.png";
import logoutIcon from "../Constant/Icons/logout.svg";
import AdminSideBar from "./Components/AdminSideBar";
import { serverUrl } from "../Constant/Static/config";
import AdminHome from "./AdminHome";
import "./Admin.css";
import AdminServices from "./Services/AdminServices";
import AdminUpdates from "./Services/AdminUpdates";
import { AuthContext } from "../Auth/AuthContext";
import PaymentServices from "./Services/PaymentServices";
import ApplicationServices from "./Services/ApplicationServices";
import Loader from "../Constant/Custom/Loader";
import CVServices from "./Services/CVServices";
import RankServices from "./Services/RankServices";
import SessionTimer from "../Auth/SessionTimer";
import AdminUnauthorized from "./Services/AdminUnauthorized";
import AdminDailyStats from './Services/AdminDailyStats';
import SeatManipulation from "./Services/SeatManipulation/SeatManipulation";
import { decryptData, encryptData } from "../Constant/Static/middleware";

function AdminDashboard() {
    const { auth, logoutAdmin } = useContext(AuthContext);
    const [loading, setLoading] = useState(true);
    const [MsgResponse, setResponse] = useState("");
    // const [inactiveTime, setInactiveTime] = useState(0);
    const navigate = useNavigate();

    const handleLogout = async () => {
        try {
            logoutAdmin();
            navigate("/admin/login");
        } catch (error) {
            console.error("Logout failed", error);
        }
    };

    useEffect(() => {
        async function fetchProtectedData() {
            const token = sessionStorage.getItem('adminToken');
            // console.log('Admin Token:', token);

            if (token) {
                try {
                    const response = await fetch(`${serverUrl}/api/admin/protected`, {
                        method: "POST",
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    });

                    if (response.status === 200) {
                        const data = await response.json();
                        // console.log(data.userInfo);
                        setLoading(false);
                    } else {
                        console.error('Access denied');
                    }
                } catch (err) {
                    // console.log(`Error while Authorize: ${err}`);
                }
            } else {
                // console.log('No Admin Token found');
            }
        }

        fetchProtectedData();
        // console.log("auth", auth);
    }, []);

    const sendData = async () => {
        const dataToSend = "Hello, secure world!";
        const encryptPassword = "AadhiLeaAcgcet";

        try {
            // Encrypting Data before sending........
            const { encryptedData, iv, authTag } = await encryptData(dataToSend, encryptPassword);

            // Send encrypted data, IV, and auth tag to the backend for decryption
            const response = await fetch(`${serverUrl}/api/test`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    encryptedData: Array.from(encryptedData),
                    iv: Array.from(iv),
                    authTag: Array.from(authTag),
                }),
            });

            const result = await response.json();

            // Decrypt the server's response
            const decryptedMessage = await decryptData(
                new Uint8Array(result.encryptedResponse),
                encryptPassword,
                new Uint8Array(result.iv),
                new Uint8Array(result.authTag)
            );

            // console.log(decryptedMessage); // Display decrypted message
        } catch (error) {
            console.error("Error:", error);
        } finally {
            // console.log("Encrypted Message: ", dataToSend);
            // console.log("Decrypted Message: ", MsgResponse);
        }
    };


    if (loading) {
        return <Loader />;
    }


    return (
        <SessionTimer handleLogout={handleLogout}>
            <div className="app">
                {auth.user.accesslvl !== "S" && (
                    <AdminSideBar
                        accesslvl={auth.user.accesslvl}
                        onRouteChange={navigate}
                    />
                )}

                <div className="content">
                    <div className="header">
                        <div onClick={sendData}>
                            <img alt="TN" src={TNLogo} width={50} height={50} />
                        </div>
                        <div className="header-content">
                            <h3>GOVERNMENT OF TAMILNADU</h3>
                            <h4>Tamilnadu Lateral Entry Direct Second Year B.E/B.Tech., Admissions - 2026</h4>
                        </div>
                        <div>
                            <button className="button" onClick={handleLogout}>
                                <img alt="Logout" src={logoutIcon} width={30} height={30} />
                            </button>
                        </div>
                    </div>

                    <Routes>
                        {auth.user.accesslvl !== "S" ? (
                            <>
                                <Route path="/" element={<AdminHome />} />
                                <Route
                                    path="/application-services"
                                    element={<ApplicationServices />}
                                />
                                <Route path="/cv" element={<CVServices />} />
                                <Route
                                    path="/seat-manipulation"
                                    element={<SeatManipulation />}
                                />
                                <Route path="/admin-daily-stats" element={<AdminDailyStats />} />
                                {auth.user.accesslvl !== "J" ? (
                                    <>
                                        <Route path="/services" element={<AdminServices />} />
                                        <Route
                                            path="/payment-services"
                                            element={<PaymentServices />}
                                        />
                                        <Route path="/application-services" element={<ApplicationServices />} />
                                        <Route path="/rank-services" element={<RankServices />} />
                                        <Route path="/admin-updates" element={<AdminUpdates />} />
                                    </>
                                ) : (
                                    <>
                                        <Route path="/services" element={<AdminUnauthorized />} />
                                        <Route
                                            path="/payment-services"
                                            element={<AdminUnauthorized />}
                                        />
                                        {/* <Route path="/cv" element={<AdminUnauthorized />} /> */}
                                        <Route
                                            path="/rank-services"
                                            element={<AdminUnauthorized />}
                                        />
                                        <Route path="/admin-updates" element={<AdminUnauthorized />} />
                                        {/* <Route path="/admin-daily-stats" element={<AdminUnauthorized />} /> */}
                                    </>
                                )}
                            </>
                        ) : (
                            <Route path="/" element={<ApplicationServices />} />
                        )}
                    </Routes>
                </div>
            </div>
        </SessionTimer>
    );
}

export default AdminDashboard;
